import React, { FC } from 'react';
import { Helmet } from 'react-helmet';
import styled from 'styled-components';
import { Page } from 'components/molecules/page/page';
import { Overview } from 'components/organisms/home/overview';
import { UserGreeting } from 'components/organisms/user-greeting';
import { useTranslation } from 'hooks/use-translation';

const PageHeader = styled(Page.Header)`
  padding-bottom: var(--spacing-05) !important;
`;

export const HomePage: FC = () => {
  return (
    <Page $gray>
      <PageHeader sticky title={<UserGreeting />} />
      <Page.Content>
        <Helmet>
          <title>{useTranslation('home.title')} </title>
        </Helmet>
        <Overview />
      </Page.Content>
    </Page>
  );
};
